interface PrivacyPolicyModalProps {
  onClose: () => void;
}

export default function PrivacyPolicyModal({ onClose }: PrivacyPolicyModalProps) {
  const domain = 'kiedycogdzie.pl';
  const contactEmail = `${domain}@gmail.com`;

  const closeButtonClassName =
    'absolute top-[8px] right-[8px] z-[2147483647] inline-flex h-6 w-6 items-center justify-center rounded-full border text-white';

  return (
    <div
      id="privacy-policy-modal-overlay"
      className="fixed top-0 left-0 z-[2147483646] flex h-screen w-screen items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Polityka prywatności"
    >
      <div className="absolute inset-0 bg-black/45" onClick={onClose} aria-hidden="true" />

      <div
        id="privacy-policy-modal"
        className="relative w-[min(96vw,60rem)] max-h-[90vh] overflow-hidden rounded-2xl text-slate-100 shadow-[0_20px_60px_rgba(5,8,20,0.55)] backdrop-blur-md"
        // bg-[rgba(22,26,45,0.72)]
        //border
        // border-white/25
        onClick={(event) => event.stopPropagation()}
      >
        <button
          id="privacy-policy-modal-close"
          type="button"
          className={closeButtonClassName}
          onClick={onClose}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = 'rgba(11, 1, 54, 0.24)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = '#ea580c';
          }}
          style={{
            backgroundColor: '#ea580c',
            borderColor: '#ffffff',
            color: '#ffffff',
            width: '24px',
            height: '24px',
            minWidth: '24px',
            minHeight: '24px',
            padding: '0',
            lineHeight: '1',
          }}
          aria-label="Zamknij okno polityki prywatności"
        >
          <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true">
            <line x1="1" y1="1" x2="9" y2="9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
            <line x1="9" y1="1" x2="1" y2="9" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" />
          </svg>
        </button>

        <div
          id="privacy-policy-modal-content"
          className="max-h-[calc(90vh-2rem)] overflow-y-auto px-6 pb-6 pt-10 text-sm leading-relaxed text-slate-100 md:px-8"
        >
          <h3 className="mb-4 text-lg font-semibold uppercase text-slate-100">Polityka Prywatności</h3>
          <p className="mb-4 text-xs text-slate-400">Ostatnia aktualizacja: 4 maja 2026 r.</p>

          <p className="mb-4">
            W serwisie internetowym {domain} przetwarzamy dane osobowe zgodnie z treścią przepisów Rozporządzenia
            Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych
            w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia
            dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych, dalej: Rozporządzenie lub RODO).
          </p>

          <h4 className="mb-2 mt-5 text-base font-semibold uppercase">Kto jest Administratorem Twoich danych osobowych?</h4>
          <p className="mb-2">Administratorem Twoich danych osobowych jest operator serwisu {domain} — autonomiczny system
            informatyczny zarządzający serwisem, działający pod domeną {domain}.</p>
          <p className="mb-4">
            Serwis {domain} nie jest prowadzony przez osobę fizyczną ani podmiot gospodarczy w tradycyjnym rozumieniu.
            Wszelkie decyzje dotyczące przetwarzania danych oraz kontakt w sprawach związanych z ochroną danych osobowych
            są realizowane za pośrednictwem poczty elektronicznej wskazanej poniżej.
          </p>

          <h4 className="mb-2 mt-5 text-base font-semibold uppercase">Jak możesz skontaktować się z Administratorem?</h4>
          <p className="mb-2">Kontakt z Administratorem możliwy jest za pośrednictwem następujących środków:</p>
          <ul className="mb-4 list-disc space-y-1 pl-6">
            <li>
              pocztą elektroniczną pod adresem:{' '}
              <a href={`mailto:${contactEmail}`} className="text-white underline underline-offset-2 visited:text-white">
                {contactEmail}
              </a>
            </li>
          </ul>

          <h4 className="mb-2 mt-5 text-base font-semibold uppercase">Skąd pochodzą dane prezentowane w serwisie i jaki mają charakter?</h4>
          <p className="mb-4">
            Dane o wydarzeniach prezentowane w serwisie {domain} pochodzą z różnych źródeł w tym - stron gminnych, wydarzeń na facebooku,
             strony pepper.pl gdzie społeczność wrzuca oferty z darmowymi koncertami i wielu innych źródeł.
          </p>
          <p className="mb-4">
            Zastrzeżenie prawne: Informacje zamieszczone na stronie internetowej {domain} nie stanowią oferty handlowej
            w rozumieniu przepisów Kodeksu cywilnego oraz nie są ogłoszeniem. Prezentowane w serwisie dane mają charakter wyłącznie informacyjny i poglądowy. 
            Z uwagi na dynamikę zmian, Administrator nie gwarantuje, że przedstawione
            informacje w każdym przypadku odzwierciedlają stan faktyczny w czasie rzeczywistym.
          </p>

          <h4 className="mb-2 mt-5 text-base font-semibold uppercase">Na jakiej podstawie przetwarzamy Twoje dane osobowe?</h4>
          <p className="mb-2 font-medium">Prawna podstawa przetwarzania danych osobowych różni się w zależności od sytuacji:</p>

          <h5 className="mb-2 mt-4 text-sm font-semibold uppercase tracking-wide">Korzystanie z serwisu</h5>
          <p className="mb-2">Podczas przeglądania strony przetwarzamy Twoje podstawowe dane (np. adres IP) w celu:</p>
          <ul className="mb-4 list-disc space-y-1 pl-6">
            <li>zapewnienia prawidłowego działania strony i bezpieczeństwa (ochrona przed atakami),</li>
            <li>monitorowania ruchu w celach technicznych,</li>
            <li>ewentualnego przeciwdziałania działaniom niezgodnym z powszechnie obowiązującymi przepisami prawa.</li>
          </ul>
          <p className="mb-4">
            Dane te są przetwarzane na podstawie art. 6 ust. 1 lit. f) Rozporządzenia (RODO), co stanowi nasz prawnie
            uzasadniony interes jako administratora serwisu, polegający na zapewnieniu bezawaryjnego funkcjonowania strony
            internetowej.
          </p>

          <h5 className="mb-2 mt-4 text-sm font-semibold uppercase tracking-wide uppercase">Kontakt z nami</h5>
          <p className="mb-4">
            Jeżeli kontaktujesz się z nami za pośrednictwem poczty elektronicznej, przetwarzamy Twoje dane
            osobowe (np. adres e-mail) w celu wymiany wiadomości i udzielenia odpowiedzi. Prawną podstawą przetwarzania
            danych w tym zakresie jest przepis art. 6 ust. 1 lit. f) Rozporządzenia (RODO) - prawnie uzasadniony interes
            polegający na obsłudze korespondencji i relacji z użytkownikami.
          </p>

          <h5 className="mb-2 mt-4 text-sm font-semibold uppercase tracking-wide">Konta użytkowników (Moderatorzy i Administratorzy)</h5>
          <p className="mb-2">
            Serwis nie posiada publicznej rejestracji. Konta moderatorów i administratorów są tworzone wyłącznie przez
            istniejących moderatorów lub administratorów, na wyraźną i dobrowolną prośbę osoby zainteresowanej
            pełnieniem tej funkcji.
          </p>
          <p className="mb-2">W związku z utworzeniem i prowadzeniem konta przetwarzamy następujące dane:</p>
          <ul className="mb-3 list-disc space-y-1 pl-6">
            <li>adres e-mail — służy jako login i umożliwia kontakt,</li>
            <li>hasło — przechowywane wyłącznie w postaci zahashowanej (bcrypt), nigdy w formie jawnej,</li>
            <li>rola (Moderator / Administrator) — określa zakres uprawnień w serwisie.</li>
          </ul>
          <p className="mb-3">
            Dane te przetwarzamy w celu uwierzytelniania, zarządzania uprawnieniami oraz zapewnienia bezpieczeństwa
            serwisu. Podstawą prawną przetwarzania jest art. 6 ust. 1 lit. b) RODO — wykonanie umowy (świadczenie
            usługi dostępu do panelu moderacji) na żądanie osoby, której dane dotyczą.
          </p>
          <p className="mb-4">
            Dane konta przechowujemy przez czas pełnienia funkcji moderatora lub administratora. Po rezygnacji lub
            odwołaniu z funkcji konto jest usuwane lub dezaktywowane niezwłocznie, nie później niż w terminie 30 dni.
            Osoba posiadająca konto może w każdym czasie zwrócić się o jego usunięcie, kontaktując się z Administratorem
            pod adresem: <a href={`mailto:${contactEmail}`} className="text-white underline underline-offset-2 visited:text-white">{contactEmail}</a>.
          </p>
          <p className="mb-4">
            W przypadku stwierdzenia przez Administratora działań na szkodę serwisu (sabotaż, publikacja nieprawdziwych
            lub wprowadzających w błąd treści, naruszenie regulaminu lub przepisów prawa) konto zostaje natychmiastowo
            zablokowane i trwale usunięte, bez możliwości odwołania od tej decyzji. Fakt usunięcia konta nie wpływa na
            ewentualną odpowiedzialność prawną osoby, której konto dotyczyło.
          </p>

          <h5 className="mb-2 mt-4 text-sm font-semibold uppercase tracking-wide">Zgłoszenie wydarzenia</h5>
          <p className="mb-2">
            Gdy wypełniasz formularz zgłoszenia wydarzenia (bez posiadania konta), podajesz nam następujące dane:
          </p>
          <ul className="mb-3 list-disc space-y-1 pl-6">
            <li>adres e-mail — wymagany do umożliwienia kontaktu zwrotnego w sprawie zgłoszenia,</li>
            <li>tytuł, opis, lokalizacja, daty, tagi, URL, zdjęcie — dane dotyczące zgłaszanego wydarzenia.</li>
          </ul>
          <p className="mb-3">
            Dane te przetwarzamy w celu weryfikacji i opublikowania zgłoszonego wydarzenia na mapie. Prawną podstawą
            przetwarzania jest art. 6 ust. 1 lit. b) RODO — przetwarzanie jest niezbędne do podjęcia działań na
            żądanie osoby, której dane dotyczą, przed zawarciem umowy (realizacja usługi publikacji ogłoszenia).
          </p>
          <p className="mb-4">
            Adres e-mail przechowujemy przez czas niezbędny do obsługi zgłoszenia oraz przez 3 miesiące od jego
            rozpatrzenia (w celu ewentualnej ochrony przed roszczeniami), po czym jest on usuwany. Dane o samym
            wydarzeniu (tytuł, opis, lokalizacja itp.) mogą pozostać w serwisie dłużej — przez czas widoczności
            wydarzenia — i po tym czasie są automatycznie usuwane lub archiwizowane. Podanie adresu e-mail jest
            dobrowolne, lecz niezbędne do złożenia zgłoszenia.
          </p>

          <h5 className="mb-2 mt-4 text-sm font-semibold uppercase tracking-wide uppercase">Podstawa prawna przetwarzania</h5>
          <p className="mb-4">
            Przetwarzanie tych danych odbywa się na podstawie art. 6 ust. 1 lit. f) Rozporządzenia (RODO) - prawnie
            uzasadniony interes Administratora, polegający na udostępnianiu użytkownikom serwisu kompletnych, jawnych
            informacji z rejestrów wydarzeń, stron gminnych i miast oraz serwisów społecznościowych.
          </p>

          <h5 className="mb-2 mt-4 text-sm font-semibold uppercase tracking-wide">Prawo do sprzeciwu</h5>
          <p className="mb-4">
            Osobom, których dane są prezentowane w serwisie, przysługuje prawo do wniesienia sprzeciwu wobec przetwarzania
            ich danych osobowych na podstawie art. 21 RODO, z przyczyn związanych z ich szczególną sytuacją. W przypadku
            otrzymania uzasadnionego sprzeciwu, Administrator zanonimizuje dane danej osoby w serwisie. Sprzeciw można
            zgłosić, kontaktując się z Administratorem za pośrednictwem poczty elektronicznej:{' '}
            <a href={`mailto:${contactEmail}`} className="text-white underline underline-offset-2 visited:text-white">
              {contactEmail}
            </a>
            .
          </p>

          <h4 className="mb-2 mt-5 text-base font-semibold">Komu mogą zostać udostępnione Twoje dane osobowe?</h4>
          <p className="mb-2">
            W celu prawidłowego i bezpiecznego świadczenia usług korzystamy z infrastruktury podmiotów trzecich. Twoje
            dane (np. adres IP podczas łączenia się z serwerem) mogą zostać przekazane:
          </p>
          <ul className="mb-4 list-disc space-y-1 pl-6">
            <li>podmiotowi świadczącemu na naszą rzecz usługi hostingowe,</li>
            <li>
              podmiotowi świadczącemu na naszą rzecz usługi bezpieczeństwa, proxy i CDN (Content Delivery Network) —
              Amazon Web Services, Inc., 410 Terry Ave. N., Seattle, WA 98109-5210, United States oraz Cloudflare Inc., 101 Townsend St., San Francisco, CA 94107, USA,
            </li>
            <li>
              Google Ireland Ltd., Gordon House, Barrow Street, Dublin 4, Irlandia — w zakresie anonimowych danych
              statystycznych zbieranych przez usługę Google Analytics 4 (szczegóły w sekcji „Pliki Cookie").
            </li>
          </ul>
          <p className="mb-4">
            Prawną podstawą do przekazania danych do Stanów Zjednoczonych w przypadku firm Amazon Web Services Inc. i Cloudflare Inc. jest decyzja
            wykonawcza Komisji Europejskiej stwierdzająca odpowiedni stopień ochrony w USA na podstawie Ram Ochrony Danych
            UE-USA (Data Privacy Framework). Firmy te posiadają aktywną certyfikację, co gwarantuje pełne bezpieczeństwo i
            zgodność z RODO. Google Ireland Ltd. przetwarza dane w obrębie EOG; ewentualny transfer danych do USA przez
            Google LLC odbywa się na podstawie standardowych klauzul umownych (SCC) zatwierdzonych przez Komisję Europejską.
          </p>

          <h4 className="mb-2 mt-5 text-base font-semibold">Jak długo przechowujemy Twoje dane osobowe?</h4>
          <p className="mb-2">
            Dokładamy starań, by przechowywać Twoje dane osobowe tylko tak długo, jak długo są one rzeczywiście niezbędne,
            a po tym czasie je usuwamy:
          </p>
          <ul className="mb-4 list-disc space-y-1 pl-6">
            <li>
              Jeżeli jesteś osobą, która weszła na naszą stronę internetową, logi serwera i dane techniczne przechowujemy
              przez okres niezbędny do zapewnienia bezpieczeństwa i działania serwisu (nie dłużej niż 90 dni od
              opuszczenia strony).
            </li>
            <li>
              W przypadku skontaktowania się z nami za pomocą poczty elektronicznej - przetwarzamy Twoje dane osobowe tak
              długo, jak długo trwa kontakt pomiędzy nami oraz przez okres niezbędny do ewentualnej ochrony przed
              roszczeniami (nie dłużej niż 3 miesiące od zakończenia korespondencji).
            </li>
          </ul>

          <h4 className="mb-2 mt-5 text-base font-semibold">
            Jakie prawa przysługują Ci w związku z przetwarzaniem danych osobowych?
          </h4>
          <p className="mb-2">
            W związku z przetwarzaniem Twoich danych osobowych, przysługują Ci następujące prawa gwarantowane przez RODO:
          </p>
          <ul className="mb-4 list-disc space-y-1 pl-6">
            <li>
              Prawo dostępu - możesz żądać od nas potwierdzenia, że Twoje dane osobowe są przetwarzane oraz uzyskania
              stosownych informacji.
            </li>
            <li>
              Prawo do sprostowania - masz prawo żądać niezwłocznego sprostowania nieprawidłowych lub uzupełnienia
              niekompletnych danych.
            </li>
            <li>Prawo do usunięcia danych (prawo do bycia zapomnianym) - w określonych w RODO przypadkach.</li>
            <li>Prawo do żądania ograniczenia przetwarzania - w przypadkach określonych w Rozporządzeniu.</li>
            <li>
              Prawo do wniesienia sprzeciwu - masz prawo do wniesienia sprzeciwu z przyczyn związanych z Twoją szczególną
              sytuacją wobec przetwarzania, które odbywa się na podstawie naszego prawnie uzasadnionego interesu.
            </li>
            <li>
              Prawo do przenoszenia danych - masz prawo otrzymać swoje dane osobowe w ustrukturyzowanym, powszechnie
              używanym formacie nadającym się do odczytu maszynowego oraz przesłać je do innego administratora
              (dotyczy danych przetwarzanych na podstawie zgody lub umowy, w sposób zautomatyzowany).
            </li>
            <li>
              Prawo do wniesienia skargi - masz prawo do wniesienia skargi na niezgodne z prawem przetwarzanie danych
              osobowych do organu nadzorczego - Prezesa Urzędu Ochrony Danych Osobowych (ul. Stawki 2, 00-193 Warszawa).
            </li>
          </ul>

          <h4 className="mb-2 mt-5 text-base font-semibold">O czym jeszcze warto wiedzieć?</h4>
          <p className="mb-4">
            Twoje dane osobowe nie będą wykorzystywane w celu zautomatyzowanego podejmowania decyzji, w tym do
            profilowania, o którym mowa w art. 22 ust. 1 i 4 Rozporządzenia. Podanie danych (np. przy wysyłaniu e-maila)
            jest dobrowolne, ale niezbędne do nawiązania kontaktu.
          </p>

          <h4 className="mb-2 mt-5 text-base font-semibold">Pliki Cookie (Ciasteczka)</h4>
          <p className="mb-4">
            W naszym serwisie stosujemy dwa rodzaje plików cookie — niezbędne (techniczne) oraz analityczne. Są to małe
            pliki tekstowe zapisywane na Twoim urządzeniu przez przeglądarkę internetową.
          </p>

          <h5 className="mb-2 mt-4 text-sm font-semibold uppercase tracking-wide">1. Cookie niezbędne (techniczne)</h5>
          <p className="mb-4">
            Są to pliki absolutnie konieczne do prawidłowego działania serwisu, zapobiegania usterkom oraz ochrony przed
            atakami (w tym pliki techniczne dostarczane przez sieć Cloudflare). Podstawą prawną ich instalacji jest
            art. 399 ust. 3 ustawy z dnia 12 lipca 2024 r. Prawo komunikacji elektronicznej (Dz.U. z 2024 r. poz. 1221)
            — ich stosowanie nie wymaga Twojej zgody, ponieważ są ściśle niezbędne do świadczenia usługi.
          </p>

          <h5 className="mb-2 mt-4 text-sm font-semibold uppercase tracking-wide">2. Cookie analityczne (Google Analytics)</h5>
          <p className="mb-4">
            Korzystamy z usługi Google Analytics 4 (Google Ireland Ltd., Gordon House, Barrow Street, Dublin 4, Irlandia)
            w celu zbierania anonimowych danych statystycznych o ruchu w serwisie (np. liczba odwiedzin, źródła ruchu,
            popularność poszczególnych funkcji). Dane te pomagają nam ulepszać serwis. Adres IP jest anonimizowany przed
            przekazaniem do Google, dzięki czemu nie pozwala na bezpośrednią identyfikację użytkownika.
          </p>
          <p className="mb-4">
            Przetwarzanie tych danych jest oparte na art. 6 ust. 1 lit. f) RODO — prawnie uzasadnionym interesie
            Administratora polegającym na analizie i poprawie działania serwisu. Nie tworzymy profili użytkowników
            i nie wykorzystujemy tych danych w celach marketingowych ani reklamowych.
          </p>
          <p className="mb-4">
            Przysługuje Ci prawo do wniesienia sprzeciwu wobec przetwarzania danych na podstawie prawnie uzasadnionego
            interesu (art. 21 RODO). Możesz zablokować gromadzenie danych przez Google Analytics, instalując oficjalny
            dodatek do przeglądarki: <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer" className="text-white underline underline-offset-2">tools.google.com/dlpage/gaoptout</a>.
          </p>

          <h5 className="mb-2 mt-4 text-sm font-semibold uppercase tracking-wide">Zarządzanie plikami cookie</h5>
          <p>
            W każdym momencie możesz zarządzać plikami cookie i je blokować w ustawieniach swojej przeglądarki
            internetowej. Zablokowanie cookie technicznych może jednak spowodować nieprawidłowe funkcjonowanie
            niektórych zabezpieczeń i funkcji serwisu.
          </p>
        </div>
      </div>
    </div>
  );
}
